export default __webpack_public_path__ + "static/news2-3-3375573ad439289c07e9561470f40fc7.jpg";